const doc = [({"da":({"js":({"team_surveys":({"feedback_states":({"has_all":"Har alt", "has_none":"Har ingen", "has_started":"Startede"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;